import React from 'react'
import { connect } from "react-redux";
import { idEmpresa, admin } from '../../constans/constants';
import { subirArchivoCsv } from "../usuario/UsuarioService";
import { obtenerListaEmpresas } from "../empresas/EmpresaService";
import DropzoneComponent from "../componentes/DropzoneComponent";
import BreadCrumComponent from "../componentes/BreadCrumComponent";
import { esSesionAdmin } from './Usuario';
import PantallaCarga from '../mensajeFlash/PantallaCarga';
import {
    limpiarErrorCampo, integrarConHandleInput,
    mostrarErroresEnFormulario, configurarLimpiezaAutomatica
} from '../../constans/form-error-utils';
import { validateForm } from '../../constans/validationUtils';

class ImportarUsuarios extends React.Component {

    constructor(props) {
        super(props);

        const originalHandleInput = this.handleChangeSelect;

        this.handleChangeSelect = integrarConHandleInput(this, originalHandleInput);

        this.state = {
            listaUsuarios: null,
            pesoArchivoMb: null,
            listaEmpresas: [],
            listaEmpresaSelected: null,
            showErrors: false
        };
    }

    reglasValidacionCampos = {

        listaEmpresaSelected: [
            {
                customValidator: (value, formData) => {
                    if (!admin())
                        return true
                    else
                        return !value
                }, message: 'Debe seleccionar una empresa'
            },
        ],
        listaUsuarios: [
            { required: true, message: 'Debe cargar la lista de usuarios a importar' },
            {
                allowedExtensions: ['csv'],
                message: 'Debe cargar la lista a importar en formato csv'
            },
            {
                allowedMimeTypes: [
                    'text/csv',
                    'application/csv'
                ],
                message: 'Tipo de archivo no permitido'
            }
        ]
    }

    componentDidMount() {
        configurarLimpiezaAutomatica()
        if (admin()) {
            obtenerListaEmpresas()
                .then((res) => {
                    if (res && res.datos && res.datos.length > 0) {
                        this.setState({
                            listaEmpresas: res.datos,
                            listaEmpresaSelected: res.datos[0].id
                        });
                    }
                })
                .catch((error) => {
                    this.setState({
                        listaEmpresas: [],
                        mostrarMensajeFlash: true,
                        mensajeFlashSeverity: "error",
                        mensajeFlash: "Ha ocurrido un error al obtener empresas"
                    })
                    console.error('Error obteniendo empresas:', error);
                });
        }
    }

    setBackButton = () => {
        return esSesionAdmin() ? "/admin/usuarios" : "/administracion/usuarios"
    }

    formatFileSize = (bytes, decimals = 2) => {
        if (bytes === 0) return '0 Bytes';

        const k = 1024;
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

        const i = Math.floor(Math.log(bytes) / Math.log(k));

        return parseFloat((bytes / Math.pow(k, i)).toFixed(decimals)) + sizes[i];
    }

    handleArchivo = (archivo) => {

        this.setState({ listaUsuarios: archivo, nombreArchivo: archivo.name, pesoArchivoMb: this.formatFileSize(archivo.size) })
        limpiarErrorCampo("listaUsuarios")
    }

    handleChangeSelect = (e) => {
        this.setState({ listaEmpresaSelected: e.target.value })
    }

    sendFile = () => {
        this.setState({ openPantallaCarga: true });
        const { isValid, errors } = validateForm(this.state, this.reglasValidacionCampos);
        if (isValid) {
            let data = new FormData();
            data.append("file", this.state.listaUsuarios);

            this.props.subirArchivoCsv(data, admin() ? this.state.listaEmpresaSelected : idEmpresa()).then(res => {
                this.setState({ openPantallaCarga: false })
                this.props.history.push({
                    pathname: `/administracion/usuarios/importar/resultados`,
                    state: {
                        cantidadImportados: res.datos.cantidadImportados,
                        ultimoUsuarioImportado: res.datos.ultimoUsuarioImportado,
                        erroresCsv: res.datos.errores,
                    }
                });
            })
        } else {
            this.setState({ errors: errors, showErrors: true });
            mostrarErroresEnFormulario(errors);
        }

    };

    renderListaEmpresas = () => {
        if (admin()) {
            if (!this.state.listaEmpresas || this.state.listaEmpresas.length === 0) {
                return (
                    <div className="form-group">
                        <p>Cargando empresas...</p>
                    </div>
                );
            }

            return (
                <div className="form-group">
                    <select className="form-select" name="empresa" id="empresa" placeholder=""
                        onChange={this.handleChangeSelect} value={this.state.listaEmpresaSelected}>
                        {this.state.listaEmpresas.map((elemento) => (
                            <option value={elemento.id} key={elemento.id}>{elemento.nombre}</option>
                        ))}
                    </select>
                    <label htmlFor="empresa" className="form-label"> Empresa </label>
                </div>
            );
        }
        return null;
    }

    render() {
        return (
            <div>
                <div>
                    <header className="component-header">
                        <div className="page-container">
                            <BreadCrumComponent
                                backUrl={this.setBackButton}
                                breadcrumbs={
                                    [
                                        { label: 'Usuarios', path: this.setBackButton },
                                        { label: 'Importar usuarios', path: '' }
                                    ]
                                }
                            />

                            <div className="head-area">
                                <div className="caption-area">
                                    <h1 className="page-title"> Importar Lista de Usuarios </h1>
                                    <p className="page-description"> Importa lista de usuarios en lote </p>
                                </div>
                            </div>
                        </div>
                    </header>
                    <div className="wrapperContent">
                        <div className="page-container card">
                            <div className="component-carga-apariencia">

                                <div className="container-flex center-content">
                                    <div className="col">
                                        <h3 className="form-subtitle"> Cargar documento a importar </h3>
                                        <p className="form-description">  Selecciona el archivo que contenga la lista de usuarios a importar, solo en formato .csv </p>
                                        <div className="carga-documento-section" name="listaUsuarios">
                                            <div className="carga-documento-content">
                                                <DropzoneComponent onFileSelected={this.handleArchivo} archivos_soportados={["csv"]} />
                                            </div>
                                        </div>
                                        {this.state.listaUsuarios && (
                                            <div className="component-progress-upload">
                                                <div className="contentInner">
                                                    <div className="icon-shape shape-xl">
                                                        <span className="material-symbols-outlined">folder_zip</span>
                                                    </div>
                                                    <div className="progress-content">
                                                        <div className="load-info">
                                                            <span className="file-name">{this.state.listaUsuarios.name}</span>
                                                        </div>
                                                        <div className="file-info">
                                                            <span className="file-size">{this.state.pesoArchivoMb}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                        {this.renderListaEmpresas()}
                                    </div>
                                </div>
                            </div>



                            <div className="form-actions">
                                <button onClick={this.sendFile} className="btn-medium btn-primary"> Importar </button>
                                <button onClick={this.props.history.goBack}className="btn-medium btn-primary"> Cancelar </button>
                            </div>
                        </div>
                    </div>
                    <PantallaCarga mensaje={"Procesando archivo..."} />
                </div>
            </div>
        )
    }
}


const mapDispatchToProps = (dispatch) => ({
    subirArchivoCsv: (file, idEmpresa) =>
        dispatch(subirArchivoCsv(file, idEmpresa)),
});


export default connect(null, mapDispatchToProps)(ImportarUsuarios)